export default __webpack_public_path__ + "static/media/wipeout.9b82a0ba.png";